module.exports = "/_next/static/images/ActImage-b32556028fee369a1fd385f6b7dfcd61.webp";